import React, { useEffect, useState } from "react";
import { globalDbnTaxonomyCategories } from "../../../../redux/global-dbn-taxonomy-categories/action";
import { useAppDispatch } from "../../../../hooks/hooks";
import { globalDbnTaxonomySubDomainAttributes } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes/action";
import { useSelector } from "react-redux";
import { selectGlobalDbnTaxonomySubDomainAttributesListItems } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes/selector";
import { selectGlobalDbnTaxonomyCategoriesListItems } from "../../../../redux/global-dbn-taxonomy-categories/selector";
import { deepCopy } from "../../../../common/services/common.service";
import { useNavigate } from "react-router-dom";

export const GlobalDbnTaxonomySubDomainAttributesCategoryMappingsComponent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const categories = [
    { id: 1, Name: "T Shirts" },
    { id: 2, Name: "Sweatshirts" },
    { id: 3, Name: "Kurtas & Kurta Sets" },
    { id: 4, Name: "Jackets & Coats" },
    { id: 5, Name: "Sweaters" },
    { id: 6, Name: "Stoles and Scarves" },
    { id: 7, Name: "Mufflers" },
    { id: 8, Name: "Suits" },
    { id: 9, Name: "Sherwanis" },
    { id: 10, Name: "Track Shirts" },
    { id: 11, Name: "Track Suits" },
    { id: 12, Name: "Unstitched Fabrics" },
    { id: 13, Name: "Dresses" },
    { id: 14, Name: "Tops" },
    { id: 15, Name: "Trousers" },
    { id: 16, Name: "Capris" },
    { id: 17, Name: "Coordinates" },
    { id: 18, Name: "Playsuits" },
    { id: 19, Name: "Jumpsuits" },
    { id: 20, Name: "Shrugs & Blouses" },
    { id: 21, Name: "Blazers & Waistcoats" },
    { id: 22, Name: "Tights, Leggings & Jeggings" },
    { id: 23, Name: "Track Pants" },
    { id: 24, Name: "Jeans" },
    { id: 25, Name: "Shorts" },
    { id: 26, Name: "Joggers" },
    { id: 27, Name: "Dhotis & Dhoti Pants" },
    { id: 28, Name: "Churidars" },
    { id: 29, Name: "Salwars" },
    { id: 30, Name: "Dungarees & Jumpsuits" },
    { id: 31, Name: "Skirts" },
    { id: 32, Name: "Clothing Sets" },
    { id: 33, Name: "Belts" },
    { id: 34, Name: "Caps & Hats" },
    { id: 35, Name: "Kurtis, Tunics" },
    { id: 36, Name: "Sarees" },
    { id: 37, Name: "Ethnic Wear" },
    { id: 38, Name: "Palazzos" },
    { id: 39, Name: "Dress Materials" },
    { id: 40, Name: "Lehenga Cholis" },
    { id: 41, Name: "Dupattas & Shawls" },
    { id: 42, Name: "Burqas & Hijabs" },
    { id: 43, Name: "Blouses" },
    { id: 44, Name: "Blouse Pieces" },
    { id: 45, Name: "Briefs" },
    { id: 46, Name: "Boxers" },
    { id: 47, Name: "Vests" },
    { id: 48, Name: "Robes" },
    { id: 49, Name: "Night Suits" },
    { id: 50, Name: "Thermal Wear" },
    { id: 51, Name: "Swim Bottoms" },
    { id: 52, Name: "Swimwear" },
    { id: 53, Name: "Bra" },
    { id: 54, Name: "Shapewear" },
    { id: 55, Name: "Sleepwear & Loungewear" },
    { id: 56, Name: "Camisoles" },
    { id: 57, Name: "Lingerie Sets & Accessories" },
    { id: 58, Name: "Bath Robes" },
    { id: 59, Name: "Towels" },
    { id: 60, Name: "Pyjamas" },
    { id: 61, Name: "Party Wear" },
    { id: 62, Name: "Innerwear & Sleepwear" },
    { id: 63, Name: "Nightwear & Loungewear" },
    { id: 64, Name: "Watches" },
    { id: 65, Name: "Gloves" },
    { id: 66, Name: "Socks" },
    { id: 67, Name: "Stockings" },
    { id: 68, Name: "Laces" },
    { id: 69, Name: "Soles & Charms" },
    { id: 70, Name: "Shoe Racks & Organisers" },
    { id: 71, Name: "Shoe Care - Accessories" },
    { id: 72, Name: "Flip-Flops & Flats" },
    { id: 73, Name: "Sandals & Floaters" },
    { id: 74, Name: "Backpacks" },
    { id: 75, Name: "Handbags" },
    { id: 76, Name: "Trolley, Luggage & Suitcases" },
    { id: 77, Name: "Formal Shoes" },
    { id: 78, Name: "Casual Shoes" },
    { id: 79, Name: "Sports Shoes" },
    { id: 80, Name: "Outdoor Shoes" },
    { id: 81, Name: "Work & Safety Shoes" },
    { id: 82, Name: "Ethnic Shoes" },
    { id: 83, Name: "Boots" },
    { id: 84, Name: "Heels" },
    { id: 85, Name: "Contact Lenses" },
    { id: 86, Name: "Eye Glasses" },
    { id: 87, Name: "Eye Glass Frames" },
    { id: 88, Name: "Sunglasses" },
    { id: 89, Name: "Contact Lens Cases" },
    { id: 90, Name: "Contact Lens Solutions" },
    { id: 91, Name: "Contact Lens Tweezers" },
    { id: 92, Name: "Eyeglasses Pouches & Cases" },
    { id: 93, Name: "Microfiber Wipes" },
    { id: 94, Name: "Eyewear Slings" },
    { id: 95, Name: "Bracelets" },
    { id: 96, Name: "Chains" },
    { id: 97, Name: "Mangalsutra" },
    { id: 98, Name: "Anklets" },
    { id: 99, Name: "Bangles & Bracelets" },
    { id: 100, Name: "Necklaces" },
    { id: 101, Name: "Earrings" },
    { id: 102, Name: "Jewellery Sets" },
    { id: 103, Name: "Nosepins & Noserings" },
    { id: 104, Name: "Pendants" },
    { id: 105, Name: "Rings" },
    { id: 106, Name: "Toe Rings" },
    { id: 107, Name: "Gold Coins" },
    { id: 108, Name: "Brooch" },
    { id: 109, Name: "Pouch" },
    { id: 110, Name: "Keychain" },
  ];


  const attributes = [
    { id: "1", Name: "WaterResistant", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "3", Name: "Display", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "4", Name: "GlassMaterial", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "5", Name: "ColourName", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "6", Name: "SportType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "7", Name: "BaseMetal", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "8", Name: "Plating", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "9", Name: "CareInstructions", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "10", Name: "WashType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "11", Name: "Weight", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "12", Name: "Length", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "13", Name: "Breadth", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "14", Name: "Height", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "15", Name: "Features", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "16", Name: "FabricFinish", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "17", Name: "Material", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "18", Name: "MaterialFinish", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "19", Name: "Pattern", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "20", Name: "Occasion", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "21", Name: "Season", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "22", Name: "Trend", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "23", Name: "Fit", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "24", Name: "Collar", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "25", Name: "Neck", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "26", Name: "Bundles", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "27", Name: "MaxSaleQuantity", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "28", Name: "Hemline", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "29", Name: "Lining", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "30", Name: "NumPockets", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "31", Name: "Reversible", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "32", Name: "BottomType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "33", Name: "TopType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "34", Name: "FrontStyling", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "35", Name: "SleeveLength", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "36", Name: "SweatshirtType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "37", Name: "Fragile", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "38", Name: "Liquid", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "39", Name: "Hazardous", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "40", Name: "PowerType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "41", Name: "BatteryLife", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "42", Name: "Bluetooth", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "43", Name: "CallFunction", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "44", Name: "HeartRateMonitor", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "45", Name: "Pedometer", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "46", Name: "SleepMonitor", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "47", Name: "SPO2Monitor", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "48", Name: "Warranty", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "49", Name: "BuckleMaterial", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "50", Name: "BuckleType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "51", Name: "WaistRise", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "52", Name: "SocksLength", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "53", Name: "FootwearType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "54", Name: "Insole", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "55", Name: "SoleMaterial", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "56", Name: "ToeShape", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "57", Name: "Outsole", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "58", Name: "FastenType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "59", Name: "Midsole", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "60", Name: "BackpackStyle", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "61", Name: "ClosureType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "62", Name: "StoneType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "63", Name: "GemType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "64", Name: "DialShape", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "65", Name: "FrameType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "66", Name: "FrameShape", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "67", Name: "FrameColour", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "68", Name: "FrameSize", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "69", Name: "FrameMaterial", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "70", Name: "FrameStyle", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "71", Name: "FaceShape", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "72", Name: "LensMaterial", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "73", Name: "LensColour", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "74", Name: "LaptopCompartment", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "75", Name: "StrapType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "76", Name: "Volume", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "77", Name: "LockType", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "78", Name: "Ornamentation", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "79", Name: "Coverage", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "80", Name: "Padding", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "81", Name: "Seam", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "82", Name: "WaistBand", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "83", Name: "Sustainability", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "84", Name: "Handcrafted", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "85", Name: "Craftmark", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },
    { id: "86", Name: "StyleCode", value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"] },

  ];

  const [categoriesList, setCategoriesList] = useState<any>(categories);
  const [attributesList, setAttributesList] = useState<any>(attributes);
  const [initialMappings, setInitialMappings] = useState<any>();
  const listGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesListItems)
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const [mappings, setMappings] = useState(initialMappings);
  const [categorySearch, setCategorySearch] = useState("");
  const [attributeSearch, setAttributeSearch] = useState("");

  const handleCategoryClick = (categoryId: number) => {
    setSelectedCategories(
      [categoryId]
    );
  };

  const handleCategoryToggle = (categoryId: number) => {
    setSelectedCategories(prev =>
      prev.includes(categoryId) ? prev.filter(id => id !== categoryId) : [...prev, categoryId]
    );
  };

  const handleValueChange = (attrId: string, index: number, value: string) => {
    if (selectedCategories === null) return;
    const updatedMappings = { ...mappings }; // Create a copy of the current mappings
    selectedCategories.forEach(item => {
      if (!updatedMappings[item]) return; // Ensure the item exists in mappings
      updatedMappings[item] = {
        ...updatedMappings[item],
        [attrId]: {
          ...updatedMappings[item][attrId],
          [index === 0 ? "value1" : "value2"]: value,
        },
      };
    });
    setMappings(updatedMappings); // Call setMappings once after processing
  };

  const fetchGlobalDbnTaxonomyCategories = async () => {
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomyCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData:
    {
        "Context": {},
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNCategoryId",
          "SortOrder": "desc",
        }
      }
    }))
  }

  const fetchGlobalDbnTaxonomySubDomainAttributes = async () => {
    await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomySubDomainAttributes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/dbn-fetch`,
      entity: 'GlobalDbnTaxonomySubDomainAttributes',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    if (listGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      if (listGlobalDbnTaxonomySubDomainAttributesData?.result?.items.length > 0) {
        const attributes = deepCopy(listGlobalDbnTaxonomySubDomainAttributesData?.result?.items)
        const items = attributes?.map(item => {
          return {
            ...item,
            value1: ["MC", "MO", "IO"], value2: ["B2C", "B2B", "B2C-EXPORT", "B2B-EXPORT"]
          }
        })
        // setAttributesList(items)
      }
      dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'list' }))
    }
  }, [listGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    if (listGlobalDbnTaxonomyCategoryData?.isSuccess) {
      // setCategoriesList(listGlobalDbnTaxonomyCategoryData?.result?.items)
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
    }
  }, [listGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    console.log('categoriesList', categoriesList)
  }, [categoriesList]);

  useEffect(() => {
    console.log('attributesList', attributesList)
  }, [attributesList]);

  useEffect(() => {
    if (!attributesList && !categoriesList) {
      setInitialMappings(null)
      return
    }
    const initialMappings: { [categoryId: number]: { [attrId: string]: { value1: string; value2: string } } } =
      Object?.fromEntries(categoriesList?.map(category => [
        category.id,
        Object?.fromEntries(attributesList?.map(attr => [
          attr.id,
          { value1: "", value2: "" }
        ]))
      ]));
    setInitialMappings(initialMappings)
  }, [categoriesList, attributesList]);

  useEffect(() => {
    fetchGlobalDbnTaxonomyCategories();
    fetchGlobalDbnTaxonomySubDomainAttributes();
  }, []);

  const back = () => {
    navigate(-1)
  }

  return (
    <div className="flex h-screen p-2 w-full">
      <div className=" flex flex-col w-full">
        <div className='p-4 bg-white w-full'>
          <div className="flex flex-row justify-between items-center">
            <h3 className="text-2xl font-bold">{`Category Atribute Mappings`}</h3>
            <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
              Back
            </button>
          </div>
        </div>
        <div className="flex flex-row w-full">
          {/* Category Sidebar */}
          <div className="w-1/4 bg-gray-100 p-4 overflow-y-auto">
            <h2 className="text-lg font-semibold mb-3">Categories</h2>
            <input
              type="text"
              className="w-full p-2 mb-2 border rounded"
              placeholder="Search categories..."
              value={categorySearch}
              onChange={(e) => setCategorySearch(e.target.value)}
            />
            <ul>
              {categoriesList?.filter(cat => cat?.Name?.toLowerCase().includes(categorySearch?.toLowerCase())).map((cat) => (
                <li key={cat.id} className="p-2 cursor-pointer flex items-center">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={selectedCategories?.includes(cat.id)}
                    onChange={() => handleCategoryToggle(cat.id)}
                  />
                  <div onClick={() => handleCategoryClick(cat.id)}>
                    {cat.Name}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Attribute Section */}
          <div className="flex-1 p-4 overflow-y-auto">
            <h2 className="text-lg font-semibold mb-3">Attributes</h2>
            <input
              type="text"
              className="w-full p-2 mb-2 border rounded"
              placeholder="Search attributes..."
              value={attributeSearch}
              onChange={(e) => setAttributeSearch(e.target.value)}
            />
            {selectedCategories.length > 0 ? (
              <table className="w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 border">Attribute</th>
                    <th className="p-2 border">Condition</th>
                    <th className="p-2 border">Network</th>
                  </tr>
                </thead>
                <tbody>
                  {attributesList?.filter(attr => attr.Name.toLowerCase().includes(attributeSearch?.toLowerCase())).map(attr => (
                    <tr key={attr.id}>
                      <td className="p-2 border">{attr.Name}</td>
                      <td className="p-2 border">
                        <select
                          className="w-full p-1 border rounded"
                          // value={mappings && mappings[selectedCategories[0]] && mappings[selectedCategories[0]][attr.id]?.value1 || ""}
                          onChange={(e) => handleValueChange(attr.id, 0, e.target.value)}
                        >
                          <option value="">Select</option>
                          {attr.value1.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </td>
                      <td className="p-2 border">
                        <select
                          className="w-full p-1 border rounded"
                          // value={mappings[selectedCategories[0]][attr.id]?.value2 || ""}
                          onChange={(e) => handleValueChange(attr.id, 1, e.target.value)}
                        >
                          <option value="">Select</option>
                          {attr.value2.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Select categories to see attributes</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
